import React, { useCallback, useEffect, useRef } from 'react';
import { BottomSheet, IconClose, Stack } from '@adc/parallax-component-library';
import { RichText } from 'Components/utility';
const modalStyles = {
    content: {
        overflow: 'auto',
        minHeight: '40vh',
        maxHeight: '80vh',
    },
};
export const InfoModal = ({ isOpen, title, content, customBody, additionalContent, app, handleClose, }) => {
    const ref = useRef(null);
    useEffect(() => {
        if (isOpen) {
            ref.current?.present();
        }
        else {
            ref.current?.dismiss();
        }
    }, [isOpen]);
    const handleDismiss = useCallback(() => {
        handleClose();
    }, [handleClose]);
    return (React.createElement(BottomSheet, { ref: ref, topNavigationProps: {
            buttonStart: {
                element: React.createElement(IconClose, null),
                onPress: handleClose,
                label: 'close',
            },
            title,
        }, onBackdropClick: handleDismiss, onDismiss: handleDismiss, testID: "info-modal", enableDynamicSizing: true, scrollable: true },
        React.createElement("div", { style: modalStyles.content },
            React.createElement(Stack, { gridRowGap: "$4", flex: 1, marginBottom: "$4" },
                content && React.createElement(RichText, { text: content, color: "$text.100", testID: "content" }),
                customBody,
                additionalContent && (React.createElement(RichText, { text: additionalContent, color: app === 'libreView' ? '$text.60' : '$text.100', fontToken: app === 'libreView' ? '$bodySmall.default' : '$bodyBase.default', testID: "additionalContent" }))))));
};
